import { render, staticRenderFns } from "./table-nfse-importadas.vue?vue&type=template&id=1a1fcb1c&"
import script from "./table-nfse-importadas.vue?vue&type=script&lang=js&"
export * from "./table-nfse-importadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports